import {
  ICalendarHoliday,
  IOvertimeRequest,
  IMentionAttachmentComment,
  OvertimeRequest,
  OvertimeRequestComment,
  IUser,
  User
} from '@/models';
import { ITransition } from '@/models/transition';
import { IOvertimeRequestState } from '@/store/overtime-request';

import { IOvertimeRequestGetters } from './getters.types';

export const getters: IOvertimeRequestGetters = {
  getOvertimeCount(state: IOvertimeRequestState): number {
    return state.count;
  },

  getOvertimeRequests(state: IOvertimeRequestState): IOvertimeRequest[] {
    return state.overtimeRequests.map(data => new OvertimeRequest(data));
  },

  getOvertimeRequestById: (state: IOvertimeRequestState) => (
    id: number
  ): IOvertimeRequest | undefined => {
    const data = state.overtimeRequests.find(overtime => overtime.id === id);
    if (!data) {
      return undefined;
    }

    return new OvertimeRequest(data);
  },

  getOvertimeRequestActivities: (
    state: IOvertimeRequestState
  ): ITransition[] => {
    return state.activities;
  },

  getOvertimeRequestComments: (
    state: IOvertimeRequestState
  ): IMentionAttachmentComment[] => {
    return state.comments.map(data => new OvertimeRequestComment(data));
  },

  getOvertimeRequestCommentById: (state: IOvertimeRequestState) => (
    id: number
  ): IMentionAttachmentComment | undefined => {
    const data = state.comments.find(
      paymentrequisition => paymentrequisition.id === id
    );
    if (!data) {
      return undefined;
    }

    return new OvertimeRequestComment(data);
  },

  getLastCreatedOvertimeRequestCommentId(
    state: IOvertimeRequestState
  ): number | null {
    return state.lastCreatedOvertimeRequestCommentId;
  },

  // Mentions
  getOvertimeRequestMentionableUsers(state: IOvertimeRequestState): IUser[] {
    return state.mentionableUsers.map(data => new User(data));
  }
};
